<span *appFeatureFlag="'isInstagramAvailable'" class="social-item-wrapper">
  <a href="https://www.instagram.com/Identibase/"
    target="_blank"
    aria-label="identi on Instagram"
    class="socials-icon">
    <div class="blob-wrapper" [ngClass]="badgeStyleClass"
     [ngStyle]="{ 'width': badgeWrapperSize, 'height': badgeWrapperSize }">
      <svg  class="blob" [ngClass]="badgeStyleClass"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="252"
          height="240"
          viewBox="0 0 252 240">
        <defs>
          <path id="a-2"
                d="M103.514 1.31C66.118 6.34-8.186 70.586.737 136.292c8.923 65.625 92.15 108.617 134.98 102.777 72.926-9.897 103.75-68.22 94.828-133.926C221.622 39.517 177.25-8.667 103.514 1.31">
          </path>
        </defs>
        <g fill="none" fill-rule="evenodd" transform="translate(10)">
          <mask id="b-2" fill="#fff">
            <use xlink:href="#a-2"></use>
          </mask>
          <use fill-rule="nonzero" xlink:href="#a-2"></use>
          <g fill-rule="nonzero" mask="url(#b-2)">
            <path d="M-10-1h253v241H-10z"></path>
          </g>
        </g>
      </svg>
      <div class="blob-content">
        <fa-icon [ngStyle]="{ 'font-size': badgeIconSize }" [icon]="['fab', 'instagram']"></fa-icon>
      </div>
    </div>
  </a>
</span>
